import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { referenceDataHubCards } from "../../navigation/appNavigation";
import { SectionLabels } from "../../utils/navigation/pageTitles";

const ReferenceDataHubPage = () => (
    <SectionHubPage title={SectionLabels.referenceData} cards={referenceDataHubCards} />
);

export { ReferenceDataHubPage };
